export const LOCAL_STORAGE_KEY_MAP = {
  token: 'token',
  applicantsPageSize: 'applicantsPageSize',
  casesPageSize: 'casesPageSize',
  recentProductUpdateNoteUrl: 'recentProductUpdateNoteUrl',
} as const

export const DOCUMENT_BODY_ELEMENT = typeof document !== 'undefined' ? document.body : undefined
